import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const checkStatus = async (tokens: any, userAccessToken: string, txnId: string) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.checkStatus,
    method: 'POST',
    config: sitConfig(tokens),
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
    body: {
      transactionId: txnId,
    },
  }
  const data = await executeRequest(request)
  return responseParser(data.data)
}

export { checkStatus }
